import { computed, Service, signal } from '@angular/core';

@Service()
export class LoadingService {
  private readonly pendingRequests = signal(0);
  readonly isLoading = computed(() => this.pendingRequests() > 0);

  /**
   *
   * Función utilizada para registrar una petición en curso para mostrar el indicador de carga
   */
  start(): void {
    this.pendingRequests.update((count) => count + 1);
  }

  /**
   *
   * Función utilizada para descontar una petición en curso, sin bajar de cero
   */
  stop(): void {
    this.pendingRequests.update((count) => Math.max(0, count - 1));
  }
}
